import { Controller } from '@hotwired/stimulus';
import TomSelect from 'tom-select';

export default class extends Controller {
  static targets = ['orderFor', 'address'];

  connect() {
    this.allAddressOptions = this.collectAddressOptions();
    this.initializeAddressSelect();
    this.filterAddressOptions();
  }

  disconnect() {
    if (this.addressSelect) this.addressSelect.destroy();
  }

  filterAddressOptions() {
    if (!this.hasAddressTarget) return;

    const addressOptions = this.addressOptionsForSelectedCustomer();
    const selectedValue = this.selectedAddressValue(addressOptions);

    this.replaceAddressOptions(addressOptions, selectedValue);
  }

  initializeAddressSelect() {
    if (!this.hasAddressTarget) return;

    if (this.addressTarget.tomselect) {
      this.addressSelect = this.addressTarget.tomselect;
      return;
    }

    this.addressSelect = new TomSelect(this.addressTarget);
  }

  addressOptionsForSelectedCustomer() {
    return this.allAddressOptions.filter(
      (option) => option.customerId === this.selectedCustomerId(),
    );
  }

  selectedAddressValue(addressOptions) {
    const currentValue = this.addressSelect
      ? this.addressSelect.getValue()
      : this.addressTarget.value;
    const currentAddressStillAvailable = addressOptions.some(
      (option) => option.value === currentValue,
    );
    const fallbackAddress =
      addressOptions.find((option) => option.delivery) || addressOptions[0];

    return currentAddressStillAvailable
      ? currentValue
      : fallbackAddress?.value || '';
  }

  replaceAddressOptions(addressOptions, selectedValue) {
    this.addressTarget.options.length = 0;

    addressOptions.forEach((addressOption) => {
      this.addressTarget.add(
        this.buildAddressOption(addressOption, selectedValue),
      );
    });

    this.addressTarget.value = selectedValue;
    this.refreshAddressSelect(addressOptions, selectedValue);
  }

  refreshAddressSelect(addressOptions, selectedValue) {
    if (!this.addressSelect) return;

    this.addressSelect.clear(true);
    this.addressSelect.clearOptions(() => false);
    this.addressSelect.addOptions(
      addressOptions.map((addressOption) => ({
        text: addressOption.text,
        value: addressOption.value,
      })),
    );
    this.addressSelect.setValue(selectedValue, true);
    this.addressSelect.refreshOptions(false);
  }

  collectAddressOptions() {
    if (!this.hasAddressTarget) return [];

    return Array.from(this.addressTarget.options).map((option) => ({
      customerId: option.dataset.customerId,
      delivery: option.dataset.delivery === 'true',
      text: option.text,
      value: option.value,
    }));
  }

  buildAddressOption(addressOption, selectedValue) {
    const option = new Option(
      addressOption.text,
      addressOption.value,
      false,
      addressOption.value === selectedValue,
    );
    option.dataset.customerId = addressOption.customerId;
    option.dataset.delivery = addressOption.delivery;

    return option;
  }

  selectedCustomerId() {
    if (this.hasOrderForTarget && this.orderForTarget.value) {
      return this.orderForTarget.value;
    }

    return this.data.get('mainCustomerId');
  }
}
